import { SET_MODE, SET_SELECTED, SET_SELECTED_BACKUP } from 'r_constants/noApi.constants'

export const setMode = (mode) => async dispatch => dispatch({ type: SET_MODE, mode })

export const setSelected = (selected) => async dispatch => dispatch({ type: SET_SELECTED, selected })

export const setSelectedBackup = (selected) => async dispatch => dispatch({ type: SET_SELECTED_BACKUP, selected })